import serverURL from "../../config/serverConfig";
import { userContext } from '../../contexts/userContext';
import { useContext, useState, useEffect } from 'react';
import { useUserClients, useUserProjects } from "../../hooks/db"; // Import the function to get clients
import Client from "./Client";
import { Link } from "react-router-dom";

export default function Clients() {

    const user_id = useContext(userContext);
    const userClients = useUserClients(user_id[0]); // Use the custom hook
    const [selectedClient, setSelectedClient] = useState(null);
    console.log("userClients: ", userClients)

    const displayClient = (clientID) => {
        console.log("displaying client: ", clientID);
        setSelectedClient(clientID);
    }

    const clientWidget = (

            selectedClient ? (
                <div id="clientWidget">
                    <Client clientID={selectedClient} />
                </div>
            ) : (
                <div style={{ display: "none"}}>
                </div>
            )

    )

    return (
        userClients && userClients.length != 0 ? 

            <div className="clientsContainer m-auto px-6 mt-6 items-center max-w-[1200px]">
                {/* <h2 className="tracking-widest mb-2 text-[#ffee00]">CLIENTS</h2> */}
                <ul id="clientsList" className="">
                    <li className="clientsHeader grid grid-cols-3 tracking-widest text-sm text-[#ffee00]  p-2">
                        <div className="clientName">ARTIST</div>
                        <div className="clientEmail">EMAIL</div>
                        <div className="clientEmail">PHONE</div>
                    </li>
                        {userClients.map(client => (
                            <>
                                {/* <li key={client.client_id} onClick={() => displayClient(client.client_id)} className="clientItem">
                                    <div>{client.name}</div>
                                    <div>{client.email}</div>
                                </li> */}
                                <Link
                                    to="/Client"
                                    state={{ client_id: client.client_id }}
                                    key={client.client_id}
                                    className="hoverLeft hoverBright"
                                >
                                    <li key={client.client_id} onClick={() => displayClient(client.client_id)} className="clientItem grid grid-cols-3 px-2 py-[1px] uppercase text-sm">
                                        <div>{client.name}</div>
                                        <div>{client.email}</div>
                                        <div>{client.phone}</div>
                                    </li>
                                </Link>
                            </>

                        ))}
                </ul>
                {clientWidget}
            </div>
        :
            <>
                No Clients Created
            </>
    );
}